import type { IJobApplicationStore } from './index';

const updateSearch = async (jobApplicationStore: IJobApplicationStore) => {
  const { uiState, lastResultSearchText, loadJobApplications } =
    jobApplicationStore;
  if (uiState.search !== lastResultSearchText) {
    await loadJobApplications({
      searchText: uiState.search,
      page: uiState.page,
    });
  }
};

const updateBucket = async (
  jobApplicationStore: IJobApplicationStore,
  initialLoad: boolean,
) => {
  const { uiState, lastResultSearchText, bucket, loadJobApplications } =
    jobApplicationStore;

  if (initialLoad || uiState.bucket !== bucket || lastResultSearchText !== '') {
    await loadJobApplications({ bucket: uiState.bucket, page: uiState.page });
  }
};

export const updateApplicationList = async (
  jobApplicationStore: IJobApplicationStore,
  initialLoad: boolean,
) => {
  if (jobApplicationStore.uiState.search) {
    await updateSearch(jobApplicationStore);
    return;
  }

  await updateBucket(jobApplicationStore, initialLoad);
};

export const updatePage = async (jobApplicationStore: IJobApplicationStore) => {
  const { uiState, currentPage } = jobApplicationStore;

  if (uiState.page !== currentPage) {
    await jobApplicationStore.onPageChange(uiState.page);
  }
};

export const updateOverlay = async (
  jobApplicationStore: IJobApplicationStore,
) => {
  const { uiState } = jobApplicationStore;

  if (uiState.overlay) {
    jobApplicationStore.showOverlay(uiState.overlay);
  } else {
    jobApplicationStore.hideOverlay();
  }
};

export const updateSelectedDetails = async (
  jobApplicationStore: IJobApplicationStore,
  initialLoad: boolean,
) => {
  const { uiState, showDetails, hideDetails } = jobApplicationStore;
  const { selectedProspectId, tab } = uiState;

  if (selectedProspectId) {
    await showDetails(selectedProspectId, initialLoad, tab);
  } else {
    hideDetails();
  }
};
